/**
 * схема для настроек таблицы клиентов
 * @property {array} settingsItems - элементы настроект
 */
let schemeSettingsUserClients = {
    columnSettings: {
        name: {
            type: 'text'
        },
        id: {
            type: 'dropDown',
            prompt: 'Без менеджера!',
            selected: [],
            isManyItems: true
        },
        lastUploaded: {
            type: 'text'
        }
    },
    labels: {
        name: 'Группхеды',
        id: 'Менеджеры',
        lastUploaded: 'Дата последней загрузки'
    }
}

export default schemeSettingsUserClients;